module.exports = __webpack_public_path__ + "042dff2d68ebed9e93fcb218c538ba5a.MP3";